export function addSpacesToCamelCaseString(input: string): string {
  const formattedString = input.replace(/([a-z])([A-Z])/g, '$1 $2');
  return formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
}
